import { Skeleton, Radio, FormControlLabel, RadioGroup } from "@mui/material";

export const SavedAddressSkeleton = () => {
  return (
    <div className="card mt-4">
      <div className="card-body">
        <h4 className="fs-16 fw-6 mb-3">
          <Skeleton width="150px" />
        </h4>
        <RadioGroup>
          {/* Create multiple skeleton items */}
          {[...Array(3)].map((_, index) => (
            <div key={index} className="row">
              {index > 0 && <hr />} {/* Add hr only between items */}
              <FormControlLabel
                value={`skeleton-${index}`} // Dummy value for radio
                control={<Radio color="secondary" disabled />}
                label={
                  <div className="row">
                    <div className="col-md-1">
                      <Skeleton variant="circular" width={40} height={40} />
                    </div>
                    <div className="col-md-11">
                      <div>
                        <Skeleton
                          width="80%"
                          height={20}
                          style={{ marginBottom: "5px" }}
                        />
                        <Skeleton width="100%" height={15} />
                      </div>
                    </div>
                  </div>
                }
                className="col-md-12"
              />
            </div>
          ))}
        </RadioGroup>
      </div>
    </div>
  );
};
